import { render } from "./B2bProfilePassword.vue?vue&type=template&id=31cf8ea0&scoped=true&lang=pug"
import script from "./B2bProfilePassword.vue?vue&type=script&lang=js"
export * from "./B2bProfilePassword.vue?vue&type=script&lang=js"

import "./B2bProfilePassword.vue?vue&type=style&index=0&id=31cf8ea0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cf8ea0"]])

export default __exports__